// // src/pages/Users.js
// import React, { useState, useMemo, useRef, useEffect } from "react";
// import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Search, ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

// const SORTABLE_FIELDS = ["firstName", "email", "locationName", "quantityCount"];

// export default function Users({
//   customers,
//   columns,
//   loading,
//   paginationModel,
//   setPaginationModel,
//   totalElements,
//   search,
//   setSearch,
//   status,
//   setStatus,
//   planFilter,
//   setPlanFilter,
//   openAddCustomer,
//   isAdmin
// }) {
//   const [sortField, setSortField] = useState(null);
//   const [sortDirection, setSortDirection] = useState("asc");
//   const [statusOpen, setStatusOpen] = useState(false);
//   const statusRef = useRef(null);

//   const { page, pageSize } = paginationModel;
//   const totalPages = Math.ceil(totalElements / pageSize);
//   const startRow = page * pageSize + 1;
//   const endRow = Math.min((page + 1) * pageSize, totalElements);

//   // Close status dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (statusRef.current && !statusRef.current.contains(e.target)) {
//         setStatusOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const statusOptions = [
//     { label: "All Status", value: "" },
//     { label: "Active", value: "true" },
//     { label: "Inactive", value: "false" },
//   ];

//   const selectedLabel =
//     statusOptions.find((o) => o.value === status)?.label || "All Status";

//   const handlePageChange = (newPage) => {
//     setPaginationModel({ ...paginationModel, page: newPage });
//   };

//   const handlePageSizeChange = (e) => {
//     setPaginationModel({ page: 0, pageSize: parseInt(e.target.value) });
//   };

//   const handleSort = (field) => {
//     if (!SORTABLE_FIELDS.includes(field)) return;
//     if (sortField === field) {
//       setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortDirection("asc");
//     }
//   };

//   const sortedCustomers = useMemo(() => {
//     if (!sortField) return customers;

//     return [...customers].sort((a, b) => {
//       let valA = a[sortField];
//       let valB = b[sortField];

//       if (Array.isArray(valA)) valA = valA.join(", ");
//       if (Array.isArray(valB)) valB = valB.join(", ");

//       if (typeof valA === "number" && typeof valB === "number") {
//         return sortDirection === "asc" ? valA - valB : valB - valA;
//       }

//       const strA = (valA || "").toString().toLowerCase();
//       const strB = (valB || "").toString().toLowerCase();
//       if (strA < strB) return sortDirection === "asc" ? -1 : 1;
//       if (strA > strB) return sortDirection === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [customers, sortField, sortDirection]);

//   const SortIcon = ({ field }) => {
//     if (!SORTABLE_FIELDS.includes(field)) return null;
//     if (sortField !== field)
//       return <ChevronsUpDown size={14} className="ml-1 text-green-200" />;
//     return sortDirection === "asc" ? (
//       <ChevronUp size={14} className="ml-1 text-white" />
//     ) : (
//       <ChevronDown size={14} className="ml-1 text-white" />
//     );
//   };

//   const tableColumns = columns.filter((col) => col.field !== "actions");
//   const actionsColumn = columns.find((col) => col.field === "actions");

//   return (
//     <div className="h-full flex flex-col bg-gray-100 dark:bg-slate-900">
//       <div className="flex-1 flex flex-col min-h-0 p-3 sm:p-4 md:p-6">

//         {/* HEADER */}
//         <div className="flex-shrink-0 mb-3">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//             <div className="min-w-0">
//               <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-slate-900 dark:text-white">
//                 Customers
//               </h1>
//               <p className="mt-1 text-xs sm:text-sm text-slate-600 dark:text-slate-400">
//                 Manage all customer subscriptions
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* SEARCH + FILTER */}
//         <div className="flex-shrink-0 mb-3">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 w-full">

//             {/* Status Filter - Custom Dropdown */}
//             <div className="relative sm:w-48" ref={statusRef}>
//               <button
//                 onClick={() => setStatusOpen((prev) => !prev)}
//                 className="w-full flex items-center justify-between px-4 py-2 text-xs sm:text-sm bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-green-700 text-slate-900 dark:text-white transition-all"
//               >
//                 <span className="font-medium">{selectedLabel}</span>
//                 {statusOpen ? (
//                   <ChevronUp size={16} className="text-slate-500" />
//                 ) : (
//                   <ChevronDown size={16} className="text-slate-500" />
//                 )}
//               </button>

//               {statusOpen && (
//                 <div className="absolute top-full left-0 mt-2 w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-lg z-50 overflow-hidden">
//                   {statusOptions.map((option) => {
//                     const isSelected = status === option.value;
//                     return (
//                       <button
//                         key={option.value}
//                         onClick={() => {
//                           setStatus(option.value);
//                           setPaginationModel((prev) => ({ ...prev, page: 0 }));
//                           setStatusOpen(false);
//                         }}
//                         className={`w-full flex items-center gap-3 px-4 py-2.5 text-xs sm:text-sm transition-colors hover:bg-slate-50 dark:hover:bg-slate-700 ${
//                           isSelected
//                             ? "text-green-700 font-semibold bg-slate-50 dark:bg-slate-700"
//                             : "text-slate-700 dark:text-slate-300"
//                         }`}
//                       >
//                         {isSelected ? (
//                           <span className="text-green-600 text-base">✓</span>
//                         ) : (
//                           <span className="w-4" />
//                         )}
//                         {option.label}
//                       </button>
//                     );
//                   })}
//                 </div>
//               )}
//             </div>

//             {/* Search Input */}
//             <div className="relative w-full sm:w-80">
//               <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                 <Search size={16} className="text-slate-400" />
//               </div>
//               <input
//                 type="text"
//                 placeholder="Search by name..."
//                 className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-xs sm:text-sm bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-700 text-slate-900 dark:text-white shadow-sm"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>
//           </div>
//         </div>

//         {/* TABLE CARD */}
//         <div className="flex-1 min-h-0 bg-white dark:bg-slate-900 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">

//           <style jsx>{`
//             .table-scroll::-webkit-scrollbar {
//               width: 8px;
//               height: 8px;
//             }
//             .table-scroll::-webkit-scrollbar-track {
//               background: var(--scrollbar-track);
//             }
//             .table-scroll::-webkit-scrollbar-thumb {
//               background: var(--scrollbar-thumb);
//               border-radius: 4px;
//             }
//             .table-scroll::-webkit-scrollbar-thumb:hover {
//               background: var(--scrollbar-thumb-hover);
//             }
//             .table-scroll {
//               --scrollbar-track: rgb(241 245 249);
//               --scrollbar-thumb: rgb(203 213 225);
//               --scrollbar-thumb-hover: rgb(148 163 184);
//             }
//             .dark .table-scroll {
//               --scrollbar-track: rgb(30 41 59);
//               --scrollbar-thumb: rgb(71 85 105);
//               --scrollbar-thumb-hover: rgb(100 116 139);
//             }
//           `}</style>

//           {/* Table Container */}
//           <div className="flex-1 min-h-0 overflow-auto table-scroll relative">
//             <table className="w-full min-w-[800px]">

//               {/* Fixed Header */}
//               <thead className="bg-green-700 dark:bg-green-800 border-b-2 border-green-800 dark:border-green-900 sticky top-0 z-10">
//                 <tr>
//                   {tableColumns.map((col) => {
//                     const isSortable = SORTABLE_FIELDS.includes(col.field);
//                     return (
//                       <th
//                         key={col.field}
//                         onClick={() => handleSort(col.field)}
//                         className={`px-4 py-3 text-xs sm:text-sm font-semibold text-white whitespace-nowrap select-none ${
//                           isSortable
//                             ? "cursor-pointer hover:bg-green-600 dark:hover:bg-green-700 transition-colors"
//                             : ""
//                         }`}
//                         style={{
//                           textAlign: col.align || col.headerAlign || "left",
//                         }}
//                       >
//                         <div
//                           className="flex items-center gap-0.5"
//                           style={{
//                             justifyContent:
//                               col.headerAlign === "center"
//                                 ? "center"
//                                 : "flex-start",
//                           }}
//                         >
//                           {col.headerName}
//                           <SortIcon field={col.field} />
//                         </div>
//                       </th>
//                     );
//                   })}

//                   {/* Actions Column Header */}
//                   {actionsColumn && (
//                     <th className="px-4 py-3 text-center text-xs sm:text-sm font-semibold text-white">
//                       {actionsColumn.headerName}
//                     </th>
//                   )}
//                 </tr>
//               </thead>

//               {/* Scrollable Body */}
//               <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
//                 {loading ? (
//                   <tr>
//                     <td
//                       colSpan={tableColumns.length + (actionsColumn ? 1 : 0)}
//                       className="text-center"
//                       style={{ height: "400px", paddingTop: "80px" }}
//                     >
//                       <div
//                         style={{
//                           position: "absolute",
//                           left: "50%",
//                           top: "50%",
//                           transform: "translate(-50%, -50%)",
//                         }}
//                         className="flex items-center justify-center gap-2"
//                       >
//                         <div className="w-5 h-5 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></div>
//                         <span className="text-slate-600 dark:text-slate-400">
//                           Loading...
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : sortedCustomers.length === 0 ? (
//                   <tr>
//                     <td
//                       colSpan={tableColumns.length + (actionsColumn ? 1 : 0)}
//                       className="px-4 text-center text-slate-500 dark:text-slate-400"
//                       style={{ height: "400px", paddingTop: "80px" }}
//                     >
//                       No customers found
//                     </td>
//                   </tr>
//                 ) : (
//                   sortedCustomers.map((row) => (
//                     <tr
//                       key={row.id}
//                       className="hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
//                     >
//                       {/* Data Cells */}
//                       {tableColumns.map((col) => {
//                         const value = row[col.field];
//                         return (
//                           <td
//                             key={col.field}
//                             className="px-4 py-3 text-xs sm:text-sm text-slate-700 dark:text-slate-300"
//                             style={{
//                               textAlign: col.align || "left",
//                             }}
//                           >
//                             {col.renderCell ? (
//                               col.renderCell({ value, row })
//                             ) : (
//                               <div className="truncate" title={value}>
//                                 {value || "N/A"}
//                               </div>
//                             )}
//                           </td>
//                         );
//                       })}

//                       {/* Actions Cell */}
//                       {actionsColumn && (
//                         <td className="px-4 py-3 text-center">
//                           {actionsColumn.renderCell({
//                             value: row[actionsColumn.field],
//                             row,
//                           })}
//                         </td>
//                       )}
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className="flex-shrink-0 bg-slate-50 dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 px-4 py-3">
//             <div className="flex flex-col sm:flex-row items-center justify-between gap-3">

//               {/* Rows per page */}
//               <div className="flex items-center gap-2 text-xs sm:text-sm text-slate-700 dark:text-slate-300">
//                 <label htmlFor="pageSize">Rows per page:</label>
//                 <select
//                   id="pageSize"
//                   value={pageSize}
//                   onChange={handlePageSizeChange}
//                   className="px-2 py-1 border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-900 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-green-500"
//                 >
//                   <option value={10}>10</option>
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                 </select>
//               </div>

//               {/* Page info */}
//               <div className="text-xs sm:text-sm text-slate-700 dark:text-slate-300">
//                 {totalElements > 0
//                   ? `${startRow}-${endRow} of ${totalElements}`
//                   : "0 of 0"}
//               </div>

//               {/* Pagination buttons */}
//               <div className="flex items-center gap-1">
//                 <button
//                   onClick={() => handlePageChange(0)}
//                   disabled={page === 0}
//                   className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
//                   title="First page"
//                 >
//                   <ChevronsLeft size={18} />
//                 </button>

//                 <button
//                   onClick={() => handlePageChange(page - 1)}
//                   disabled={page === 0}
//                   className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
//                   title="Previous page"
//                 >
//                   <ChevronLeft size={18} />
//                 </button>

//                 <span className="px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-300">
//                   Page {page + 1} of {totalPages || 1}
//                 </span>

//                 <button
//                   onClick={() => handlePageChange(page + 1)}
//                   disabled={page >= totalPages - 1}
//                   className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
//                   title="Next page"
//                 >
//                   <ChevronRight size={18} />
//                 </button>

//                 <button
//                   onClick={() => handlePageChange(totalPages - 1)}
//                   disabled={page >= totalPages - 1}
//                   className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
//                   title="Last page"
//                 >
//                   <ChevronsRight size={18} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



// old version UAT 

// src/pages/Users.js
import React, { useState, useMemo } from "react";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Search, ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

// Fields that support sorting
const SORTABLE_FIELDS = ["firstName", "email", "locationName", "quantityCount"];

export default function Users({
  customers,
  columns,
  loading,
  paginationModel,
  setPaginationModel,
  totalElements,
  search,
  setSearch,
  status,
  setStatus,
  planFilter,
  setPlanFilter,
  openAddCustomer,
  isAdmin
}) {
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc"); // "asc" | "desc"

  // Calculate pagination
  const { page, pageSize } = paginationModel;
  const totalPages = Math.ceil(totalElements / pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, totalElements);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPaginationModel({ ...paginationModel, page: newPage });
  };

  // Handle page size change
  const handlePageSizeChange = (e) => {
    setPaginationModel({ page: 0, pageSize: parseInt(e.target.value) });
  };

  // Handle column header click for sorting
  const handleSort = (field) => {
    if (!SORTABLE_FIELDS.includes(field)) return;
    if (sortField === field) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  // Sort customers client-side
  const sortedCustomers = useMemo(() => {
    if (!sortField) return customers;

    return [...customers].sort((a, b) => {
      let valA = a[sortField];
      let valB = b[sortField];

      // Handle arrays (e.g. locationName)
      if (Array.isArray(valA)) valA = valA.join(", ");
      if (Array.isArray(valB)) valB = valB.join(", ");

      // Handle numbers
      if (typeof valA === "number" && typeof valB === "number") {
        return sortDirection === "asc" ? valA - valB : valB - valA;
      }

      // Handle strings (case-insensitive)
      const strA = (valA || "").toString().toLowerCase();
      const strB = (valB || "").toString().toLowerCase();
      if (strA < strB) return sortDirection === "asc" ? -1 : 1;
      if (strA > strB) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [customers, sortField, sortDirection]);

  // Sort icon component
  const SortIcon = ({ field }) => {
    if (!SORTABLE_FIELDS.includes(field)) return null;
    if (sortField !== field) return <ChevronsUpDown size={14} className="ml-1 text-slate-400" />;
    return sortDirection === "asc"
      ? <ChevronUp size={14} className="ml-1 text-green-600" />
      : <ChevronDown size={14} className="ml-1 text-green-600" />;
  };

  // Filter out the 'actions' field from columns for rendering
  const tableColumns = columns.filter(col => col.field !== 'actions');
  const actionsColumn = columns.find(col => col.field === 'actions');

  return (
    <div className="h-full flex flex-col bg-gray-100 dark:bg-slate-900">
      <div className="flex-1 flex flex-col min-h-0 p-3 sm:p-4 md:p-6">
        
        {/* HEADER - Fixed at top */}
        <div className="flex-shrink-0 mb-3">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="min-w-0">
              <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-slate-900 dark:text-white">
                Customers
              </h1>
              <p className="mt-1 text-xs sm:text-sm text-slate-600 dark:text-slate-400">
                Manage all customer subscriptions
              </p>
            </div>
          </div>
        </div>

        {/* SEARCH + FILTER - Fixed below header */}
        <div className="flex-shrink-0 mb-3">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 w-full">
            {/* Status Filter - LEFT */}
            <select
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                setPaginationModel((prev) => ({ ...prev, page: 0 }));
              }}
              className="px-3 py-2 text-xs sm:text-sm bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-700 cursor-pointer sm:w-48 text-slate-900 dark:text-white"
            >
              <option value="">All Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>

            {/* Search Input - RIGHT */}
            <div className="relative w-full sm:w-80">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Search size={16} className="text-slate-400" />
              </div>
              <input
                type="text"
                placeholder="Search by name..."
                className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-xs sm:text-sm bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-700 text-slate-900 dark:text-white"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* TABLE CARD - Takes remaining height with scrollable body */}
        <div className="flex-1 min-h-0 bg-white dark:bg-slate-900 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col">
          
          <style jsx>{`
            .table-scroll::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }
            .table-scroll::-webkit-scrollbar-track {
              background: var(--scrollbar-track);
            }
            .table-scroll::-webkit-scrollbar-thumb {
              background: var(--scrollbar-thumb);
              border-radius: 4px;
            }
            .table-scroll::-webkit-scrollbar-thumb:hover {
              background: var(--scrollbar-thumb-hover);
            }
            .table-scroll {
              --scrollbar-track: rgb(241 245 249);
              --scrollbar-thumb: rgb(203 213 225);
              --scrollbar-thumb-hover: rgb(148 163 184);
            }
            .dark .table-scroll {
              --scrollbar-track: rgb(30 41 59);
              --scrollbar-thumb: rgb(71 85 105);
              --scrollbar-thumb-hover: rgb(100 116 139);
            }
          `}</style>
          
          {/* Table Container with fixed header and scrollable body */}
          <div className="flex-1 min-h-0 overflow-auto table-scroll">
            <table className="w-full min-w-[800px]">
              {/* Fixed Header */}
              <thead className="bg-slate-50 dark:bg-slate-800 border-b-2 border-slate-200 dark:border-slate-700 sticky top-0 z-10">
                <tr>
                  {/* Data Columns */}
                  {tableColumns.map((col) => {
                    const isSortable = SORTABLE_FIELDS.includes(col.field);
                    return (
                      <th
                        key={col.field}
                        onClick={() => handleSort(col.field)}
                        className={`px-4 py-3 text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300 whitespace-nowrap select-none ${
                          isSortable
                            ? "cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
                            : ""
                        }`}
                        style={{
                          textAlign: col.align || col.headerAlign || "left",
                        }}
                      >
                        <div
                          className="flex items-center gap-0.5"
                          style={{
                            justifyContent:
                              col.headerAlign === "center" ? "center" : "flex-start",
                          }}
                        >
                          {col.headerName}
                          <SortIcon field={col.field} />
                        </div>
                      </th>
                    );
                  })}

                  {/* Actions Column */}
                  {actionsColumn && (
                    <th className="px-4 py-3 text-center text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300">
                      {actionsColumn.headerName}
                    </th>
                  )}
                </tr>
              </thead>

              {/* Scrollable Body */}
              <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                {loading ? (
                  <tr>
                    <td
                      colSpan={tableColumns.length + (actionsColumn ? 1 : 0)}
                      className="px-4 py-12 text-center"
                    >
                      <div className="flex items-center justify-center gap-2">
                        <div className="w-5 h-5 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                        <span className="text-slate-600 dark:text-slate-400">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : sortedCustomers.length === 0 ? (
                  <tr>
                    <td
                      colSpan={tableColumns.length + (actionsColumn ? 1 : 0)}
                      className="px-4 py-12 text-center text-slate-500 dark:text-slate-400"
                    >
                      No customers found
                    </td>
                  </tr>
                ) : (
                  sortedCustomers.map((row) => (
                    <tr
                      key={row.id}
                      className="hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
                    >
                      {/* Data Cells */}
                      {tableColumns.map((col) => {
                        const value = row[col.field];

                        return (
                          <td
                            key={col.field}
                            className="px-4 py-3 text-xs sm:text-sm text-slate-700 dark:text-slate-300"
                            style={{
                              textAlign: col.align || "left",
                            }}
                          >
                            {col.renderCell ? (
                              col.renderCell({ value, row })
                            ) : (
                              <div className="truncate" title={value}>
                                {value || "N/A"}
                              </div>
                            )}
                          </td>
                        );
                      })}

                      {/* Actions Cell */}
                      {actionsColumn && (
                        <td className="px-4 py-3 text-center">
                          {actionsColumn.renderCell({
                            value: row[actionsColumn.field],
                            row,
                          })}
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination - Fixed at bottom */}
          <div className="flex-shrink-0 bg-slate-50 dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 px-4 py-3">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">

              {/* Rows per page */}
              <div className="flex items-center gap-2 text-xs sm:text-sm text-slate-700 dark:text-slate-300">
                <label htmlFor="pageSize">Rows per page:</label>
                <select
                  id="pageSize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  className="px-2 py-1 border border-slate-300 dark:border-slate-600 rounded bg-white dark:bg-slate-900 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
              </div>

              {/* Page info */}
              <div className="text-xs sm:text-sm text-slate-700 dark:text-slate-300">
                {totalElements > 0 ? `${startRow}-${endRow} of ${totalElements}` : "0 of 0"}
              </div>

              {/* Pagination buttons */}
              <div className="flex items-center gap-1">
                <button
                  onClick={() => handlePageChange(0)}
                  disabled={page === 0}
                  className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
                  title="First page"
                >
                  <ChevronsLeft size={18} />
                </button>

                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
                  title="Previous page"
                >
                  <ChevronLeft size={18} />
                </button>

                <span className="px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-300">
                  Page {page + 1} of {totalPages || 1}
                </span>

                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= totalPages - 1}
                  className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
                  title="Next page"
                >
                  <ChevronRight size={18} />
                </button>

                <button
                  onClick={() => handlePageChange(totalPages - 1)}
                  disabled={page >= totalPages - 1}
                  className="p-1.5 rounded hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-slate-700 dark:text-slate-300"
                  title="Last page"
                >
                  <ChevronsRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}